'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/canonical/missing/missing.controller',
],function(
    angular,
    SPCanonicalMissCtrl
){
    var app=angular.module('app.seospider.exam.analysis.canonical.missing', []);
    app.controller("SPCanonicalMissCtrl",SPCanonicalMissCtrl);
    return app;
});